import { DatumValue, Point } from '@nivo/line';
import moment from 'moment';
import { COLORS, COLORS_HEX } from '../../constants/colors';
import { ProfitLoss } from '../ProfitLoss';
import { LineChartData } from '../Strategies/types';
import { Debug } from '../Debug/Debug';
import { Fragment } from 'react';
import { CurrencySymbolEnum } from '../../constants/enums';

export const Tooltip = ({
  data,
  useVariation = false,
  usePercentage = false,
  events,
  slice: { points },
  suffix,
}: {
  data: LineChartData[];
  useVariation?: boolean;
  usePercentage?: boolean;
  events?: { date: string; title: string }[];
  slice: {
    id: DatumValue;
    height: number;
    width: number;
    x0: number;
    x: number;
    y0: number;
    y: number;
    points: Point[];
  };
  suffix?: string;
}) => (
  <div className="bg-white dark:bg-grey-90 dark:border-grey-80 p-6 border border-grey-10 rounded-lg shadow-lg">
    <div className="flex items-center uppercase text-grey-50 ml-3">
      {`${moment(points[0].data.x).format('dddd')},
        ${points[0].data.xFormatted}`}
    </div>
    {[...points]
      .reverse()
      .map(
        (
          {
            color: hexColor,
            data: { yFormatted, xFormatted },
            id,
            serieId,
            index,
          },
          i
        ) => {
          const color =
            COLORS[
              Object.entries(COLORS_HEX).reduce(
                (color, [colorName, hex]) =>
                  hex === hexColor ? colorName : color,
                hexColor
              )
            ];

          const relativeIndex = index % data?.[0]?.absoluteValues?.length;

          return (
            <Fragment key={id}>
              <Debug
                data={{
                  serie: i,
                  index,
                  relativeIndex,
                  xFormatted,
                  yFormatted,
                  dataLength: data?.[i]?.absoluteValues?.length,
                  perc: data?.[i]?.percentageValues?.[relativeIndex],
                  abs: data?.[i]?.absoluteValues?.[relativeIndex],
                  useVariation,
                }}
              />
              <div
                className={`
              flex
              items-center
              gap-1
              border-l-3
              border-${color}
              pl-2
              my-2
            `}
              >
                <div className="font-semibold text-grey-70 mr-2">
                  {serieId}:
                </div>
                {useVariation ? (
                  <ProfitLoss
                    displayType="text"
                    isRow
                    percentage={data[i]?.percentageValues?.[relativeIndex]}
                    symbol={suffix as CurrencySymbolEnum}
                    value={data[i]?.absoluteValues?.[relativeIndex]}
                    valueClassName="text-black dark:text-white mr-3"
                  />
                ) : (
                  <ProfitLoss
                    displayType="text"
                    isRow
                    percentage={data[i]?.absoluteValues?.[relativeIndex]}
                    symbol={suffix as CurrencySymbolEnum}
                    value={data[i]?.percentageValues?.[relativeIndex]}
                    valueClassName="text-black dark:text-white mr-3"
                  />
                )}
              </div>
            </Fragment>
          );
        }
      )}
    {events &&
      events.find(({ date }) => date === points[0].data.xFormatted) && (
        <div className="flex flex-col my-2 border-l-3 pl-2">
          <div className="flex gap-2">
            <div className="text-grey-70">Black swan event:</div>
            <div className="font-semibold">
              {
                events.find(({ date }) => date === points[0].data.xFormatted)
                  ?.date
              }
            </div>
          </div>
          <div className="flex gap-2">
            <div className="font-semibold">
              {
                events.find(({ date }) => date === points[0].data.xFormatted)
                  ?.title
              }
            </div>
          </div>
        </div>
      )}
  </div>
);
